/* eslint-disable import/prefer-default-export */
import { useContext } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import MainContext from '../Context';
export const useApiConfig = (isEnabled = true) => {
    const queryClient = useQueryClient();
    const { apiConfig } = useContext(MainContext);
    const enabled = Boolean(apiConfig.keyProps.accountId) && isEnabled;
    return Object.assign(Object.assign({}, apiConfig), { queryOptions: Object.assign(Object.assign({}, queryClient.getQueryDefaults()), { enabled }) });
};
